import * as strings from "common/strings";
import * as config from "config";

const SUBMISSION_PAGE_PATTERN = /\/(submissions|transfers)\/[^/]+/;

// Submission pages set their own emoji favicon (ActiveSubmission), so the
// global favicon reset must skip them; every other page gets the default
// favicon back on navigation.
export const ownsFavicon = (pathname) =>
  pathname.match(SUBMISSION_PAGE_PATTERN) !== null;

export const globalTitleFor = (pathname, workspaceName) => {
  if (ownsFavicon(pathname)) return null;
  if (pathname.match(/^\/report-builder(\/|$)/) !== null) return null;
  if (pathname.startsWith("/admin"))
    return `Admin (${strings.toSentenceCase(config.ENVIRONMENT)})`;
  return workspaceName ?? "Cactus Risk Studio";
};
